// extracted by mini-css-extract-plugin
export var pager = "post-module--pager--1ZIV4";
export var block = "post-module--block--22et0";
export var background = "post-module--background--XJ0yN";
export var shade = "post-module--shade--1307S";
export var pagerLabel = "post-module--pagerLabel--AFUYz";
export var previous = "post-module--previous--ePXzl";
export var next = "post-module--next--18CjT";
export var relatedPosts = "post-module--relatedPosts--2bL_W";
export var labelIcon = "post-module--labelIcon--3HQP2";